import { render, staticRenderFns } from "./SplitTaskContainer.vue?vue&type=template&id=7c5905ae&scoped=true"
import script from "./SplitTaskContainer.vue?vue&type=script&lang=js"
export * from "./SplitTaskContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5905ae",
  null
  
)

export default component.exports